import React from 'react';
import { Button, Col, Flex, Image, Row, Space } from 'antd';
import SkeletonImage from 'antd/es/skeleton/Image';
import CookiesModal from './CookiesModal';
import { MainButton } from '../../common/form/FormElements';
import {
  acceptCookies,
  declineCookies,
} from '../../../redux/slices/localStorageSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const Cookies = () => {
  const [t] = useTranslation();

  const [modalVisible, setModalVisible] = React.useState(false);

  const dispatch = useDispatch();
  const areCookiesAccepted = useSelector(
    (s) => s.localStorage.areCookiesAccepted,
  );

  return (
    <>
      {areCookiesAccepted ? (
        <div
          style={{
            position: 'fixed',
            left: '30px',
            bottom: '30px',
            zIndex: 401,
          }}
        >
          <Button
            style={{
              padding: '3px',
            }}
            shape="circle"
            aria-label={t('Nastavenia cookies')}
            onClick={() => setModalVisible(!modalVisible)}
            icon={
              <Image
                placeholder={<SkeletonImage />}
                preview={false}
                src="/images/cookies.svg"
                alt={t('Ikona cookies')}
              ></Image>
            }
          />
        </div>
      ) : (
        <div className="security-information-container-comp">
          <Row
            style={{
              justifyContent: 'center',
            }}
          >
            <div className="accept-message">
              {t(
                'Používame súbory cookies, aby sme Vám zabezpečili čo najlepší zážitok z návštevy nášho webového portálu. Ak odmietnete používanie súborov cookies, tento web nemusí fungovať správne. Viac informácií nájdete na ',
              )}
              <a
                className={'link'}
                target={'_blank'}
                rel="noreferrer"
                href="https://www.uniza.sk/index.php?option=com_content&view=article&id=2793:cookies&catid=2"
              >
                {t('stránke univerzity o cookies')}
              </a>
              .
            </div>
          </Row>
          <Row
            style={{
              marginTop: '20px',
              justifyContent: 'center',
            }}
          >
            <Button
              className={'cookie-settings-button'}
              style={{
                background: 'rgb(21, 72, 158)',
                color: 'white',
                marginRight: '10px',
              }}
              onClick={() => {
                dispatch(acceptCookies());
              }}
            >
              {t('Prijať všetko')}
            </Button>
            <Button
              className={'cookie-settings-button'}
              style={{
                background: 'lightgray',
                color: 'black',
                marginRight: '10px',
              }}
              onClick={() => {
                dispatch(declineCookies());
              }}
            >
              {t('Odmietnuť všetko')}
            </Button>
            <Button
              className={'cookie-settings-button'}
              style={{
                color: 'black',
                background: 'lightgray',
              }}
              onClick={() => {
                dispatch(acceptCookies());
                setModalVisible(true);
              }}
            >
              {t('Prispôsobiť')}
            </Button>
          </Row>
        </div>
      )}

      <CookiesModal
        visible={modalVisible}
        onCancel={() => setModalVisible(!modalVisible)}
      />
    </>
  );
};

export default Cookies;
